import React, { useEffect, useState } from "react";
import { sanity, imageUrlBuilder } from "../client.js";
import styled from "styled-components";

const Product = () => {
	const [productData, setProductData] = useState(null);

	useEffect(() => {
		sanity
			.fetch(
				`*[_type == "productDesign"]{
			title,
			description,
			Image,
			link,
		}`
			)
			.then((data) => setProductData(data))
			.catch(console.error);
	}, []);
	return (
		<Wrapper>
			<StyledHeading
				data-aos="fade-up"
				data-aos-delay="50"
				data-aos-duration="1000"
				data-aos-easing="ease-in-out"
				data-aos-once="true"
			>
				<h2 className="Heading">
					Product <br /> Design
				</h2>
				<img src="./images/cube.png" alt="" className="cube" />
				<img
					src="./images/SuperToroid-3.png"
					alt=""
					className="donut"
				/>
			</StyledHeading>
			<main>
				{productData &&
					productData.map((brand, index) => (
						<Card
							className="card"
							key={index}
							data-aos="fade-up"
							data-aos-offset="200"
							data-aos-delay="50"
							data-aos-duration="1000"
							data-aos-easing="ease-in-out"
							data-aos-once="true"
						>
							<div className="card-image">
								<img
									src={imageUrlBuilder
										.image(brand.Image)
										.url()}
									alt="brand"
								/>
							</div>
							<div className="card-info">
								<div className="card-info-right">
									<h3 className="card-title">
										{brand.title}
									</h3>
									<p className="card-description">
										{brand.description}
									</p>
								</div>
								<div className="right-arrow-content">
									<a href={brand.link} alt="">
										<img
											src="./images/arrow-right.svg"
											alt=""
										/>
									</a>
								</div>
							</div>
						</Card>
					))}
			</main>
			<section className="additional-footer">
				<div>
					<div>
						<span className="dash"></span>More on Product Design
						<span className="dash"></span>
					</div>
					<div className="branding-asset">
						<img src="./images/product-asset.png" alt="" />
					</div>
				</div>
			</section>
		</Wrapper>
	);
};
export default Product;

const Wrapper = styled.div`
	max-width: 500px;
	margin: 0 auto;
	padding: 0 16px;
	@media (max-width: 400px) {
		overflow: hidden;
	}
	@media (min-width: 1000px) {
		max-width: 850px;
	}

	.additional-footer {
		padding-bottom: 64px;

		& > div {
			display: flex;
			flex-direction: column;
			align-items: stretch;
			& > div {
				align-self: stretch;
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 8px;
				margin-bottom: 16px;

				@media (min-width: 1000px) {
					margin-bottom: 0;
				}
			}

			@media (min-width: 1000px) {
				flex-direction: row;
				justify-content: space-between;
			}
		}

		.branding-asset {
			display: flex;
			justify-content: space-between;
			align-self: center;
			width: max-content;
			& img {
				max-width: 200px;
			}
		}
		.dash {
			display: block;
			height: 1px;
			width: 50px;
			background-color: black;

			@media (min-width: 750px) {
				width: 100px;
			}
		}
	}
`;
const StyledHeading = styled.div`
	font-family: AxiformaBold;
	text-transform: uppercase;
	font-size: 1.5rem;
	position: relative;
	width: max-content;
	padding-top: 160px;
	margin-bottom: 90px;
	& img {
		width: 80px;
		position: absolute;
		z-index: -1;
	}

	.cube {
		left: -30px;
		top: 100px;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(10px);
			}
		}
		& {
			animation: bounce 1.3s infinite alternate;
		}
	}

	.donut {
		right: -150px;
		bottom: -46px;
		width: 150px;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(10px);
			}
		}
		& {
			animation: bounce 1.4s infinite alternate;
		}
	}
`;
const Card = styled.div`
	margin: 48px 0;

	@media (min-width: 1000px) {
		margin: 128px 0;
	}

	.card-info {
		display: grid;
		grid-template-columns: 5fr 1fr;
		margin-top: 16px;
	}
	.card-title {
		font-family: AxiformaBold;
		font-size: 2.5rem;
		text-transform: capitalize;
		font-weight: 500;
	}

	.card-description {
		margin-right: 8px;

		@media (min-width: 1000px) {
			width: 55%;
			font-size: 0.8rem;
		}
	}

	.right-arrow-content {
		border: 1px solid grey;
		border-radius: 50%;
		display: grid;
		place-content: center;
		height: 50px;
		width: 50px;
		align-self: center;
		justify-self: end;
	}

	@media (min-width: 650px) {
		.card-info {
			// border: solid;

			display: grid;
			grid-template-columns: 5fr 1fr;
			margin-top: 32px;
		}

		.card-title {
			font-family: AxiformaBold;
			font-size: 2.5rem;
			text-transform: capitalize;
			font-weight: 500;
		}

		.card-description {
			max-width: 70%;
			// border: solid;
		}

		.right-arrow-content {
			margin-top: 32px;
			border: 1px solid grey;
			border-radius: 50%;
			display: grid;
			place-content: center;
			height: 50px;
			width: 50px;
			justify-self: end;
		}
	}
`;
